import * as Yup from 'yup';

const schema = Yup.object({
  owner_id: Yup.number()
    .positive()
    .nullable()
    .label('Omistaja'),
  customer_id: Yup.number()
    .positive()
    .nullable()
    .label('Asiakas'),
  location_id: Yup.number()
    .positive()
    .nullable()
    .label('Paikka'),
  range: Yup.object({
    start_at: Yup.object(),
    end_at: Yup.object()
  }).nullable()
});

export const initialValues = {
  owner_id: null,
  customer_id: null,
  location_id: null,
  range: {}
};

export default schema;
export type Schema = ReturnType<typeof schema.cast>;
